import { useTranslation } from 'react-i18next'

interface LocalBinaryFieldsProps {
  binaryPath: string
  datastorePath: string
  setBinaryPath: (value: string) => void
  setDatastorePath: (value: string) => void
}

export function LocalBinaryFields({
  binaryPath,
  datastorePath,
  setBinaryPath,
  setDatastorePath,
}: LocalBinaryFieldsProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="grid gap-4 border-t border-stone-200 pt-4 sm:grid-cols-2 dark:border-stone-700">
      <div>
        <label className="mb-1 block text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('velociraptorSettings.install.binaryPath')}
        </label>
        <input
          type="text"
          value={binaryPath}
          onChange={(ev) => {
            setBinaryPath(ev.target.value)
          }}
          className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
          placeholder={t('velociraptorSettings.placeholders.binaryPath')}
        />
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('velociraptorSettings.install.datastorePath')}
        </label>
        <input
          type="text"
          value={datastorePath}
          onChange={(ev) => {
            setDatastorePath(ev.target.value)
          }}
          className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
          placeholder={t('velociraptorSettings.placeholders.datastorePath')}
        />
      </div>
    </div>
  )
}
